module.exports = __webpack_public_path__ + "static/media/ic-expand-all.cba64831.svg";